module.exports = __webpack_public_path__ + "img/lighthouse-travel-poster.13964e90.webp";